import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconPause = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4 4C4 3.44772 4.44772 3 5 3H9C9.55228 3 10 3.44772 10 4V20C10 20.5523 9.55228 21 9 21H5C4.44772 21 4 20.5523 4 20V4Z",
		fill: "black"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14 4C14 3.44772 14.4477 3 15 3H19C19.5523 3 20 3.44772 20 4V20C20 20.5523 19.5523 21 19 21H15C14.4477 21 14 20.5523 14 20V4Z",
		fill: "black"
	})]
});
export default SvgIconPause;
